import { useState } from "react";
import Sidebar from "./Sidebar";
import React from "react";
import { getOrganizationSettings } from "./utils/storage";

export default function AppLayout({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  const organizationSettings = getOrganizationSettings();

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar */}
      <Sidebar isOpen={isOpen} onClose={() => setIsOpen(false)} />

      {/* Page content */}
      <div className="flex-1 flex flex-col overflow-y-auto xl:ml-10">
        {/* Mobile top bar */}
        <div className="xl:hidden flex items-center justify-between p-4 border-b bg-white shadow-sm">
          <button
            className="p-2 rounded-md bg-gray-100 hover:bg-gray-200"
            onClick={() => setIsOpen(true)}
          >
            {/* simple menu icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-gray-700"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
          <span className="font-semibold text-gray-800">
            {
              organizationSettings.customized_app_settings[
              "customized-app-name"
              ]
            }
          </span>
        </div>

        {/* Main scrollable content */}
        <main className="flex-1">{children}</main>
      </div>
    </div>
  );
}
